//disable-sort-imports
import '@formatjs/intl-getcanonicallocales/polyfill'
import '@formatjs/intl-locale/polyfill'
import '@formatjs/intl-numberformat/polyfill'
import '@formatjs/intl-numberformat/locale-data/en'
import '@formatjs/intl-numberformat/locale-data/pl'
import '@formatjs/intl-pluralrules/polyfill'
import '@formatjs/intl-pluralrules/locale-data/en'
import '@formatjs/intl-pluralrules/locale-data/pl'

import detect from 'detect.js'
import React from 'react'
import { Provider } from 'react-redux'
import App from './components/App'
import store from './services/store'
import { getTranslations } from './utils/localeData'
import windowErrorHandler from './utils/windowErrorHandler'
import * as appApi from './services/app/app.api'
import { AxiosResponse } from './utils/axios'
import 'intersection-observer'
import Snowfall from 'react-snowfall'
import Moment from 'moment'
import './polyfills.ts'
import PhishingAlert from './components/PhishingAlert'
import createCache from '@emotion/cache'
import PrerenderRedirect from './components/PrerenderRedirect'
import { DEFAULT_LANGUAGE_SHORT_ISO_CODE } from './utils/locale'
import { createRoot } from 'react-dom/client'
import { FALLBACK_LANG } from './utils/translations'

const ua = detect.parse(navigator.userAgent)
window.onerror = windowErrorHandler
const osName = (ua?.os?.name || '').replace(/ /g, '')
const deviceBrand = (ua?.device?.manufacturer || '').toLowerCase()

if (osName) {
  window?.document.body.classList.add(osName.toLowerCase())
}
if (deviceBrand) {
  window?.document.body.classList.add(deviceBrand)
}
let redirecting = false
let redirect: null | AxiosResponse = null

const SNOWFLAKES_ON = !(Moment().unix() > 1735171140) //auto disable 26.12.24

const cache = createCache({
  key: 'css',
  prepend: true,
  speedy: false,
})

async function bootstrap() {
  const isoCode = FALLBACK_LANG //default, cna be change to navigator language
  const matchedReservedWords = [
    '/product',
    //'/collection', // - disabled as needed in WF-3392
    // '/page', //- disabled for new cms
    '/size-guide',
    '/store-locator',
    '/gift',
    // '/ft',
    // '/fk',
    '/support/order',
    '/cart',
    '/account',
  ].filter(word => window.location.pathname.startsWith(word) || window.location.pathname == '/')
  const isPrerender = navigator.userAgent.toLowerCase().indexOf('prerender') >= 0

  //at this stage it is enough to filter right url from checking
  //TODO: may request modification for friendly urls
  if (matchedReservedWords.length === 0 && window && window.location) {
    try {
      redirect = await appApi.readRedirectFrom(window.location.pathname, window.location.hostname)
      if (redirect.data.to) {
        if (!isPrerender) {
          window.history.replaceState(redirect.data.to, redirect.data.to, redirect.data.to)
        }
        redirecting = true
      }
    } catch (error: any) {
      console.debug(error)
    }
  }

  if (isPrerender && redirecting && redirect?.data?.to) {
    // there is no need to render whole app on redirection
    createRoot(document.getElementById('app')!).render(<PrerenderRedirect to={redirect.data.to} />)
  } else if (window?.self === window?.top) {
    console.log('LANG', isoCode)
    createRoot(document.getElementById('app')!).render(
      <Provider store={store}>
        {SNOWFLAKES_ON ? (
          <Snowfall color="#f5f5f5" style={{ zIndex: 1000, position: 'fixed' }} snowflakeCount={80} speed={[0, 2]} wind={[-1, 4]} />
        ) : null}
        <App translations={await getTranslations(isoCode)} redirect={redirecting && redirect ? redirect.data.to : false} />
      </Provider>,
    )
  } else {
    createRoot(document.getElementById('app')!).render(<PhishingAlert />)
  }
}

bootstrap()
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(console.log)
